import Hero from '../component/Hero';
import Services from '../component/Services';
import 'aos/dist/aos.css';
import WarehouseImpactSection from '../component/WarehouseImpactSection';
// import '../Homepages/Secondpage.css';
import Contact from '../component/Contact';
import Ourvision from '../component/Ourvision';
import ReasonForUtilisation from '../component/ReasonForUtilisation';
import Home from '../component/Home';
import Management from '../component/Management';
import ProminentDepositors from '../component/ProminentDepositors';

function Landing() {
    return (
        <div>
            <Hero />
            <Services />
            <Home />
            <WarehouseImpactSection />
            <Management />
            <ReasonForUtilisation />
            <Ourvision />
            <ProminentDepositors />
            <Contact />
        </div>
    )
}


export default Landing